var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"TRC-ImagePlaceholder",style:({
      width: _vm.width,
      height: _vm.height,
      backgroundColor: _vm.backgroundColor
  })},[_vm._v("  \n")])
}
var staticRenderFns = []

export { render, staticRenderFns }